// extracted by mini-css-extract-plugin
export default {"LoadingFallback":"LoadingFallBack_LoadingFallback__U4rGn","LoadingFallback__logo":"LoadingFallBack_LoadingFallback__logo__Im0IX"};